import bottleFactory from './bottle';

const bottle = bottleFactory();

const {
  mediaBrowserFetchMediaList,
  mediaBrowserFetchMediaItem,
} = bottle.container;

export {
  mediaBrowserFetchMediaList,
  mediaBrowserFetchMediaItem,
};
